/* Native name capture. No request, storage dependency or cart implementation. */
(function () {
  'use strict';
  if (window.FatheadPersonalizedName) return;
  var selector = '[data-name-input]';

  function validate(input, showError) {
    var value = input.value;
    var uppercase = value.toUpperCase();
    if (uppercase !== value) {
      var start = input.selectionStart;
      var end = input.selectionEnd;
      var direction = input.selectionDirection;
      input.value = uppercase;
      if (start !== null && end !== null) {
        input.setSelectionRange(value.slice(0, start).toUpperCase().length,
          value.slice(0, end).toUpperCase().length, direction);
      }
    }
    var wrapper = input.closest('[data-personalized-name]');
    var limit = input.maxLength;
    var message = !input.value.trim() ? 'Enter the text you want printed.' :
      input.value.length > limit ? 'Use ' + limit + ' characters or fewer.' :
      !/^[\p{L}\p{M}0-9 .'’&-]+$/u.test(input.value) || /[\uFE00-\uFE0F\u{E0100}-\u{E01EF}\u20E3]/u.test(input.value) || !/[\p{L}0-9]/u.test(input.value) ?
        'Use letters, numbers, spaces, apostrophes, hyphens, periods or &. No emoji or other symbols.' : '';
    input.setCustomValidity(message);
    input.setAttribute('aria-invalid', message && showError ? 'true' : 'false');
    var remaining = Math.max(0, limit - input.value.length);
    var counter = wrapper.querySelector('[data-name-counter]');
    counter.textContent = remaining + ' left';
    counter.setAttribute('aria-label', remaining + ' characters remaining');
    var error = wrapper.querySelector('[data-name-error]');
    error.textContent = showError ? message : '';
    error.hidden = !showError || !message;
    var hint = wrapper.querySelector('.personalized-name__hint');
    if (hint) hint.hidden = !error.hidden;
    var purchase = input.closest('[data-personalized-purchase]');
    var button = purchase && purchase.querySelector('[data-personalized-add]');
    if (button) {
      // Availability and cart loading retain ownership of native disabled.
      button.setAttribute('aria-disabled', message ? 'true' : 'false');
      button.setAttribute('aria-describedby', input.getAttribute('aria-describedby'));
    }
    return !message;
  }

  function validateForm(form) {
    // form.elements includes controls associated via the form attribute.
    var fields = Array.prototype.filter.call(form.elements || [], function (el) { return el.matches(selector); });
    var firstInvalid = null;
    fields.forEach(function (input) { if (!validate(input, true) && !firstInvalid) firstInvalid = input; });
    if (firstInvalid) { firstInvalid.focus(); }
    return !firstInvalid;
  }

  document.addEventListener('input', function (event) {
    if (event.target.matches(selector) && !event.isComposing) validate(event.target, true);
  });
  document.addEventListener('compositionend', function (event) {
    if (event.target.matches(selector)) validate(event.target, true);
  });
  document.addEventListener('change', function (event) {
    if (event.target.matches(selector)) validate(event.target, true);
  });
  document.addEventListener('invalid', function (event) {
    if (event.target.matches(selector)) {
      event.preventDefault(); // Use the inline error instead of a second browser popup.
      validate(event.target, true);
      event.target.focus();
    }
  }, true);
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-personalized-add]');
    if (button && button.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      validateForm(button.form);
    }
  }, true);
  // Capturing runs before theme/app submit handlers. The drawer also invokes
  // validateForm for synthetic jQuery submits, which skip DOM capture events.
  document.addEventListener('submit', function (event) {
    if (!validateForm(event.target)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  function initialize() {
    document.querySelectorAll(selector).forEach(function (input) { validate(input, false); });
  }
  initialize();
  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pageshow', initialize);
  window.FatheadPersonalizedName = { validateForm: validateForm };
})();
